import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { VcsAgentPoolView } from "../../types";

const VCSAgentPoolsTableConnectionsCell = ({
  item: vcsAgentPool,
  ...cellProps
}: TableSimpleCellProps<VcsAgentPoolView>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{vcsAgentPool.agentConnections.length.toString()}</TableCellText>
    </TableSimpleCell>
  );
};

export default VCSAgentPoolsTableConnectionsCell;
